import { useGetPersonDisplayName } from 'library/hooks';
import { Fragment, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLoginCapablePeople } from 'reduxStore/people/selectors';
import { SelectDropDownWrapper, TagWrapper } from './styles';
import { Form, Select } from 'zui/Antd';
import { AddTeamModal, AddAssetGroupModal } from 'zComponents/molecules';
import Icon from '@ant-design/icons';
import { ReactComponent as lockIcon } from 'assets/images/icon/SmartLock_Icon.svg';

const Step1Form = () => {
	const [people, setPeople] = useState([]);
	const [teams, setTeams] = useState([]);
	const loginCapablePeople = useSelector(selectLoginCapablePeople);
	const { data: teamsData } = useSelector((state) => state.Teams);
	const displayNames = useGetPersonDisplayName(true);

	useEffect(() => {
		const notDeletedPeople = loginCapablePeople.filter((person) => !person.deletedDate);
		setPeople(notDeletedPeople);
		setTeams(teamsData);

		return () => {
			setPeople([]);
			setTeams([]);
		};
	}, [loginCapablePeople, teamsData]);
	return (
		<Fragment>
			<Form.Item name='people' label='People'>
				<Select
					mode='multiple'
					style={{ width: '100%' }}
					showSearch
					placeholder={'Select People'}
					filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
					filterSort={(optionA, optionB) =>
						optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
					}
					getPopupContainer={() => document.getElementById('selectPeopleDropdown')}
					dropdownStyle={{ position: 'relative' }}
					options={
						people &&
						people.map((person, key) => ({
							value: person.personID,
							label: displayNames[person.personID].displayName
						}))
					}
				/>
			</Form.Item>
			<SelectDropDownWrapper id='selectPeopleDropdown' />
			<div style={{ display: 'flex', alignItems: 'flex-end' }}>
				<Form.Item name='teams' label='Teams' style={{ width: '100%', margin: '0 10px 0 0' }}>
					<Select
						style={{ width: '100%', marginRight: 10 }}
						mode='multiple'
						showSearch
						placeholder={'Select Teams'}
						filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
						filterSort={(optionA, optionB) =>
							optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
						}
						getPopupContainer={() => document.getElementById('selectTeamsDropdown')}
						dropdownStyle={{ position: 'relative' }}
						options={teams.map((team) => ({
							value: team.teamID,
							label: team.name
						}))}
					/>
				</Form.Item>
				<AddTeamModal />
			</div>

			<SelectDropDownWrapper id='selectTeamsDropdown' />
		</Fragment>
	);
};
const Step2Form = () => {
	const { data: devicesData } = useSelector((state) => state.Devices);
	const { data: assetGroupsData } = useSelector((state) => state.AssetGroups);
	const {
		remoteConfig: { constants }
	} = useSelector((state) => state.FbRemoteConfig);

	const [devices, setDevices] = useState([]);
	const [groups, setGroups] = useState([]);

	useEffect(() => {
		setDevices(devicesData.filter((d) => constants.ACCESS_CONTROL_CATEGORIES.includes(d.defaultCategoryID)));
		setGroups(assetGroupsData.filter((g) => g.typeID === constants.ACCESS_CONTROL));

		return () => {
			setDevices([]);
			setGroups([]);
		};
	}, [devicesData, assetGroupsData, constants]);

	const tagRender = (props) => {
		const { label, onClose } = props;
		const onPreventMouseDown = (event) => {
			onClose();
			event.preventDefault();
			event.stopPropagation();
		};

		return (
			<TagWrapper
				icon={<Icon component={lockIcon} className='tagIcons' />}
				onMouseDown={onPreventMouseDown}
				closable={true}
				onClose={onClose}
				style={{ marginRight: 3 }}
			>
				{label}
			</TagWrapper>
		);
	};
	return (
		<Fragment>
			<Form.Item name='devices' label='Devices'>
				<Select
					tagRender={tagRender}
					mode='multiple'
					style={{ width: '100%' }}
					showSearch
					placeholder={'Select Devices'}
					filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
					filterSort={(optionA, optionB) =>
						optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
					}
					getPopupContainer={() => document.getElementById('selectDeviceDropdown')}
					dropdownStyle={{ position: 'relative' }}
					options={
						devices &&
						devices.map((device) => ({
							value: device.uID,
							label: device.name
						}))
					}
				/>
			</Form.Item>
			<SelectDropDownWrapper id='selectDeviceDropdown' />
			<div style={{ display: 'flex', alignItems: 'flex-end' }}>
				<Form.Item name='groups' label='Groups' style={{ width: '100%', margin: '0 10px 0 0' }}>
					<Select
						tagRender={tagRender}
						mode='multiple'
						style={{ width: '100%', marginRight: 10 }}
						showSearch
						placeholder={'Select Asset Groups'}
						filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
						filterSort={(optionA, optionB) =>
							optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
						}
						getPopupContainer={() => document.getElementById('selectGroupDropdown')}
						dropdownStyle={{ position: 'relative' }}
						options={
							groups &&
							groups.map((group) => ({
								value: group.groupID,
								label: group.name
							}))
						}
					/>
				</Form.Item>
				<AddAssetGroupModal forAccessControl />
			</div>
			<SelectDropDownWrapper id='selectGroupDropdown' />
		</Fragment>
	);
};

const steps = [
	{
		title: 'People & Teams',
		content: <Step1Form />
	},
	{
		title: 'Device & Groups',
		content: <Step2Form />
	}
];

export default steps;
